<section
  class="vc_row py-5 fullheight d-flex flex-wrap align-items-center bordered-section-white home-banner-bg fullheight-mobile"
  [ngStyle]="bgImage"
>
  <!-- The video is created only once the CMS has supplied its source.
       A <video> picks its source once, when it is inserted. This one used to
       be inserted before the page data arrived, with every <source src>
       still empty, so the browser settled on NETWORK_NO_SOURCE - and setting
       src afterwards does not make it look again. It only ever played because
       data-liquid-stack (removed in 9775462) happened to re-insert the section
       after the data loaded. Waiting for the source removes that dependency.

       [muted]="true" sets the muted PROPERTY. The plain `muted` attribute,
       applied by Angular after the element exists, leaves the property false,
       and browsers refuse to autoplay a video that is not muted. -->
  <div class="vidContain" *ngIf="isMobile == false && pageData && pageData['home_banner_mp4']">
    <div class="vid">
      <video autoplay muted playsinline [muted]="true" id="myVideo" poster="">
        <!--{{pageData['home_banner_bg']}}-->
        <source
          [src]="pageData['home_banner_mp4'] | safe: 'url'"
          type="video/mp4"
        />
        <source
          [src]="pageData['home_banner_webm'] | safe: 'url'"
          type="video/webm"
        />
        <source
          [src]="pageData['home_banner_ogv'] | safe: 'url'"
          type="video/ogv"
        />
      </video>
    </div>
  </div>

  <div class="liquid-row-overlay"></div>
  <div class="container">
    <div class="row">
      <div
        class="col-md-offset-1 text-center"
        [class.col-md-8]="lang == 'ar'"
        [class.col-md-10]="lang == 'en'"
      >
        <div class="ld-fancy-heading">
          <!-- <img src="../../../../../assets/img/pattern-9.gif" class="img-fluid pattern"> -->

          <h1 class="text-white mb-40 font-weight-bold">
            <span class="ld-fh-txt">
              <span
                [innerHTML]="pageData['home_banner_title']"
              ></span
              >&nbsp;<span class="text-white" id="raktyping"></span
            ></span>
          </h1>
        </div>
        <div class="ld-fancy-heading">
          <p class="text-fade-white-07 mb-55 lh-15">
            <span
              class="ld-fh-txt"
              [innerHTML]="pageData['home_banner_desc'] | safe: 'html'"
              >We provides everything you need to start your own business</span
            >
          </p>
        </div>
        <a *ngIf="pageData['home_banner_button1_url'] && pageData['home_banner_button1_label']"
          routerLink="/{{pageData['home_banner_button1_url']}}"
          [target]="pageData['home_banner_btn1_new_window'] ? '_blank' : '_self'"
          class="btn btn-solid text-uppercase semi-round border-thin font-weight-bold font-mobile-12px"
        >
          <span
            class="btn-txt"
            [innerHTML]="pageData['home_banner_button1_label']"
            >Our Services</span
          >
        </a>
        <a *ngIf="pageData['home_banner_button2_url'] && pageData['home_banner_button2_label']"
          routerLink="/{{pageData['home_banner_button2_url']}}"
          [target]="pageData['home_banner_btn2_new_window'] ? '_blank' : '_self'"
          class="btn btn-default text-uppercase semi-round btn-bordered border-thin text-white border-fade-white-03 font-weight-bold font-mobile-12px home_banner_btn_2"
        >
          <span
            class="btn-txt"
            [innerHTML]="pageData['home_banner_button2_label']"
            >Discover More</span
          >
        </a>
      </div>
    </div>
  </div>
</section>
